<section class="fullWidthCls admPageSec">
  <div class="container-fluid">
    <div class="row">
      <div class="access-denied-page-sec" *ngIf="isUserLoggedIn == false && logoutURL; else accessDenied">
        <!-- a candidate was not able to access their dashboard -->
        <div class="headerCls candidateHeaderCls">Greetings!</div><!-- earthlings! -->
        <div class="msgCls candidateMsgCls">
          <br><p>This account ({{rhId}}) does not appear to have any exams available to schedule at this time.</p>
          <br>
          <br><p>If you have purchased an exam and see this alert, we suggest the following steps:</p>
          <br><p><b>1. TRY AGAIN IN ONE HOUR.</b>&nbsp;&nbsp;Occasionally the transfer of records to the scheduler are delayed.</p>
          <br><p><b>2. CHECK YOUR ACCOUNT.</b>&nbsp;&nbsp;Make sure that the account you are using to log in matches the one you used to purchase (<a [href]="logoutURL">click here</a> to try a different account).</p>
          <br><p><b>3. CONTACT RED HAT OR YOUR RESELLER.</b>&nbsp;&nbsp;Contact Red Hat or your authorized training partner for assistance if you have purchased an exam, are using the correct account and continue to see this page when you try to log into the scheduler.</p>
          <br>
          <br><p>Thanks for your interest in Red Hat Certification!</p>
        </div>
      </div>
      <ng-template #accessDenied>
        <div class="access-denied-page-sec">
          <!-- an internal user had an issue -->
          <div class="imgCls"><img src="{{imgSrc}}"></div>
          <div class="headerCls">{{headerStr}}</div>
          <div class="msgCls" *ngIf="isUserLoggedIn == false">
            <!-- an internal user could not log in -->
            <div>{{msgStr}}</div>
            <div class="note">{{note}}</div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/page-not-found/page-not-found.component.html